import { useTranslation } from "react-i18next";
import {
  PRE_ACTIVATION_FIELD_AGENCY_BRAND_WEBSITE,
  PRE_ACTIVATION_FIELD_AGENCY_SESSION_BRAND_NAME,
  PRE_ACTIVATION_HINT_AGENCY_BRAND_WEBSITE,
  PRE_ACTIVATION_HINT_AGENCY_SESSION_BRAND_NAME,
  PRE_ACTIVATION_PLACEHOLDER_AGENCY_BRAND_WEBSITE,
  PRE_ACTIVATION_PLACEHOLDER_AGENCY_SESSION_BRAND_NAME,
} from "../../../i18n/keysTranslations";
import ReadOnlySectionGrid from "../components/ReadOnlySectionGrid";
import TextFieldBlock from "../components/TextFieldBlock";

const AgencyBrandExerciseSection = ({ control, errors, readOnly }) => {
  const { t } = useTranslation();

  return (
    <ReadOnlySectionGrid readOnly={readOnly}>
      <TextFieldBlock
        name="sessionBrandName"
        label={t(PRE_ACTIVATION_FIELD_AGENCY_SESSION_BRAND_NAME)}
        hint={t(PRE_ACTIVATION_HINT_AGENCY_SESSION_BRAND_NAME)}
        placeholder={t(PRE_ACTIVATION_PLACEHOLDER_AGENCY_SESSION_BRAND_NAME)}
        required
        control={control}
        errors={errors}
        readOnly={readOnly}
      />
      <TextFieldBlock
        name="websiteUrl"
        label={t(PRE_ACTIVATION_FIELD_AGENCY_BRAND_WEBSITE)}
        hint={t(PRE_ACTIVATION_HINT_AGENCY_BRAND_WEBSITE)}
        placeholder={t(PRE_ACTIVATION_PLACEHOLDER_AGENCY_BRAND_WEBSITE)}
        required
        control={control}
        errors={errors}
        readOnly={readOnly}
      />
    </ReadOnlySectionGrid>
  );
};

export default AgencyBrandExerciseSection;
